export default "__VITE_ASSET__CVtrw1sq__"